/* eslint-disable react/display-name */
import React from 'react';
import { Link } from 'react-router-dom';
import { DASHBOARD_PREFIX_URL } from './utility';

export default ({
  to,
  external = false,
  isDisabled = false,
  children,
  ...args
}) => {
  if (isDisabled) {
    return <a {...args}>{children}</a>;
  }
  if (external) {
    return (
      <a href={to} {...args}>
        {children}
      </a>
    );
  }

  return (
    <Link to={`${DASHBOARD_PREFIX_URL}${to}`} {...args}>
      {children}
    </Link>
  );
};
